import { useMediaQuery } from "./useMediaQuery";

// A coarse pointer is a finger: phones and tablets.
export const useIsTouchDevice = (): boolean => useMediaQuery("(pointer: coarse)");
